import { render } from "./Pagination.vue?vue&type=template&id=398b7777"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Products/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "398b7777"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('398b7777', __exports__)) {
    api.reload('398b7777', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=398b7777", () => {
    api.rerender('398b7777', render)
  })

}


export default __exports__